module.exports = __webpack_public_path__ + "img/payment.f9322632.png";